// import { getProgrammesCoordinates } from "@/actions/fetchPrograms";
import { createRoot } from "react-dom/client";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  MarkerClusterer,
  SuperClusterAlgorithm,
} from "@googlemaps/markerclusterer";
import { ProgrammeInfoWindow } from "./GoogleMapPartials/ProgrammeInfoWindow";
import PoiInfoWindow from "./GoogleMapPartials/PoiInfoWindow";
import { useDispatch } from "react-redux";
// import { deepSearchFunction } from "@/actions/deepsearch";
import {
  deepSearchFunction,
  fetchSingleProgram,
} from "../../../redux/actions/immobilierActions";
import MapDirectionsBox from "./GoogleMapPartials/MapDirectionsBox";
import LocaliseIcon from "./Icons/LocaliseIcon";
import { Spinner } from "react-bootstrap";
import getClusterIconSVG from "./Icons/ClusterIcon";
import IconBus from "./Icons/IconBus";
import CarIcon from "./Icons/CarIcon";
import BikeIcon from "./Icons/BikeIcon";
import WalkIcon from "./Icons/WalkIcon";
import ResetIcon from "./Icons/ResetIcon";
import { renderToStaticMarkup } from "react-dom/server";
import {
  Airport,
  Banques,
  Cart,
  Hospital,
  Restaurants,
  School,
} from "./Icons/MapSVGS";
import {
  clearPoiMarkers,
  haversineMeters,
} from "./GoogleMapPartials/googleMapsUtils";
import { createPortal } from "react-dom";
import ChevronDownIcon from "./Icons/ChevronDownIcon";
const CLUSTER_MAX_ZOOM = 10;
{
  /* <linearGradient xmlns="http://www.w3.org/2000/svg" id="paint0_linear_1_414" x1="28" y1="4" x2="28" y2="54" gradientUnits="userSpaceOnUse">
<stop stop-color="#52B8B8"/>
<stop offset="1" stop-color="#3C8DDB"/>
</linearGradient> */
}
const MAP_ICON_SVG_PINK = `
<svg xmlns="http://www.w3.org/2000/svg" width="56" height="62" viewBox="0 0 56 62" fill="none">
  <defs>
    <linearGradient id="g" x1="28" y1="4" x2="28" y2="54" gradientUnits="userSpaceOnUse"><stop stop-color="#D74166"/><stop offset="1" stop-color="#EE789F"/></linearGradient>
    <linearGradient id="i0" x1="-2.77576" y1="20.6303" x2="10.4364" y2="9.23637" gradientUnits="userSpaceOnUse"><stop stop-color="#F37241"/><stop offset="1" stop-color="#FABA5D"/></linearGradient>
    <linearGradient id="i1" x1="-0.121189" y1="18.4242" x2="12.9697" y2="7.15152" gradientUnits="userSpaceOnUse"><stop stop-color="#2A8AC6"/><stop offset=".2" stop-color="#2794BF"/><stop offset=".6" stop-color="#1FA4B6"/><stop offset=".8" stop-color="#1FAEAE"/><stop offset="1" stop-color="#1EB1AA"/></linearGradient>
    <linearGradient id="i2" x1="7.8424" y1="22.1455" x2="17.903" y2="13.297" gradientUnits="userSpaceOnUse"><stop stop-color="#ED3A3D"/><stop offset="1" stop-color="#F14E8D"/></linearGradient>
    <linearGradient id="i3" x1="10.4848" y1="19.8182" x2="22.7273" y2="9.15153" gradientUnits="userSpaceOnUse"><stop stop-color="#DDE04B"/><stop offset="1" stop-color="#9CCB5C"/></linearGradient>
    <linearGradient id="i4" x1="15.5394" y1="20.2667" x2="25.3576" y2="11.903" gradientUnits="userSpaceOnUse"><stop stop-color="#83796C"/><stop offset="1" stop-color="#CEA981"/></linearGradient>
    <clipPath id="c"><rect width="24" height="24"/></clipPath>
  </defs>
  <g>
  <path d="M43.5556 10.4341C47.5945 14.4666 49.9045 19.9096 49.9971 25.612C50.0897 31.3145 47.9577 36.8293 44.0518 40.9905L43.5556 41.5031L33.1841 51.857C31.8681 53.1702 30.1014 53.9348 28.2419 53.996C26.3824 54.0572 24.5692 53.4103 23.1695 52.1865L22.8175 51.857L12.4435 41.5006C8.3178 37.381 6 31.7935 6 25.9674C6 20.1413 8.3178 14.5538 12.4435 10.4341C16.5692 6.31441 22.1649 4 27.9996 4C33.8342 4 39.4299 6.31441 43.5556 10.4341Z" fill="#fff"/>
  <path d="M28 5C33.5696 5.00012 38.9107 7.20955 42.8486 11.1416C46.7037 14.9906 48.9086 20.1857 48.9971 25.6279C49.0854 31.0698 47.0508 36.333 43.3232 40.3047L42.8486 40.7949L32.4775 51.1494C31.3411 52.2833 29.8152 52.9432 28.209 52.9961C26.7031 53.0456 25.2325 52.558 24.0586 51.626L23.8281 51.4336L23.5156 51.1406L13.1504 40.793C9.21247 36.8608 7.00011 31.528 7 25.9678C7 20.4074 9.21237 15.0739 13.1504 11.1416C17.0884 7.20942 22.4302 5 28 5Z" stroke="url(#g)" stroke-width="2"/>
  </g>
  <g transform="translate(16 12)">
    <g clip-path="url(#c)">
      <path d="M5.33333 23.8788H0V8.60607L5.33333 3.27274V24V23.8788ZM0.606061 23.2727H4.72727V4.72728L0.606061 8.9697V23.3939V23.2727Z" fill="url(#i0)"/>
      <path d="M9.93942 23.8788H4.72729V0L9.93942 3.75758V24V23.8788ZM5.33336 23.2727H9.33336V4L5.33336 1.09091V23.2727Z" fill="url(#i1)"/>
      <path d="M14.6666 23.8788H9.33331V13.0909L14.6666 9.45456V23.8788ZM9.93937 23.2727H14.0606V10.6667L9.93937 13.4546V23.2727Z" fill="url(#i2)"/>
      <path d="M19.2727 23.8788H13.9394V5.09092L16.6061 3.39395L19.2727 5.09092V23.8788ZM14.6667 23.2727H18.7879V5.45456L16.7273 4.12122L14.6667 5.45456V23.3939V23.2727Z" fill="url(#i3)"/>
      <path d="M24 23.8788H18.7879V6.66666L24 10.303V23.8788ZM19.2728 23.2727H23.2728V10.5454L19.2728 7.75757V23.2727Z" fill="url(#i4)"/>
    </g>
  </g>
</svg>`;
const MAP_ICON_SVG_BLUE = `
<svg xmlns="http://www.w3.org/2000/svg" width="56" height="62" viewBox="0 0 56 62" fill="none">
  <defs>
    <linearGradient id="g" x1="28" y1="4" x2="28" y2="54" gradientUnits="userSpaceOnUse"><stop stop-color="#52B8B8"/><stop offset="1" stop-color="#3C8DDB"/></linearGradient>
    <linearGradient id="i0" x1="-2.77576" y1="20.6303" x2="10.4364" y2="9.23637" gradientUnits="userSpaceOnUse"><stop stop-color="#F37241"/><stop offset="1" stop-color="#FABA5D"/></linearGradient>
    <linearGradient id="i1" x1="-0.121189" y1="18.4242" x2="12.9697" y2="7.15152" gradientUnits="userSpaceOnUse"><stop stop-color="#2A8AC6"/><stop offset=".2" stop-color="#2794BF"/><stop offset=".6" stop-color="#1FA4B6"/><stop offset=".8" stop-color="#1FAEAE"/><stop offset="1" stop-color="#1EB1AA"/></linearGradient>
    <linearGradient id="i2" x1="7.8424" y1="22.1455" x2="17.903" y2="13.297" gradientUnits="userSpaceOnUse"><stop stop-color="#ED3A3D"/><stop offset="1" stop-color="#F14E8D"/></linearGradient>
    <linearGradient id="i3" x1="10.4848" y1="19.8182" x2="22.7273" y2="9.15153" gradientUnits="userSpaceOnUse"><stop stop-color="#DDE04B"/><stop offset="1" stop-color="#9CCB5C"/></linearGradient>
    <linearGradient id="i4" x1="15.5394" y1="20.2667" x2="25.3576" y2="11.903" gradientUnits="userSpaceOnUse"><stop stop-color="#83796C"/><stop offset="1" stop-color="#CEA981"/></linearGradient>
    <clipPath id="c"><rect width="24" height="24"/></clipPath>
  </defs>
  <g >
  <path d="M43.5556 10.4341C47.5945 14.4666 49.9045 19.9096 49.9971 25.612C50.0897 31.3145 47.9577 36.8293 44.0518 40.9905L43.5556 41.5031L33.1841 51.857C31.8681 53.1702 30.1014 53.9348 28.2419 53.996C26.3824 54.0572 24.5692 53.4103 23.1695 52.1865L22.8175 51.857L12.4435 41.5006C8.3178 37.381 6 31.7935 6 25.9674C6 20.1413 8.3178 14.5538 12.4435 10.4341C16.5692 6.31441 22.1649 4 27.9996 4C33.8342 4 39.4299 6.31441 43.5556 10.4341Z" fill="#fff"/>
  <path d="M28 5C33.5696 5.00012 38.9107 7.20955 42.8486 11.1416C46.7037 14.9906 48.9086 20.1857 48.9971 25.6279C49.0854 31.0698 47.0508 36.333 43.3232 40.3047L42.8486 40.7949L32.4775 51.1494C31.3411 52.2833 29.8152 52.9432 28.209 52.9961C26.7031 53.0456 25.2325 52.558 24.0586 51.626L23.8281 51.4336L23.5156 51.1406L13.1504 40.793C9.21247 36.8608 7.00011 31.528 7 25.9678C7 20.4074 9.21237 15.0739 13.1504 11.1416C17.0884 7.20942 22.4302 5 28 5Z" stroke="url(#g)" stroke-width="2"/>
  </g>
  <g transform="translate(16 12)">
    <g clip-path="url(#c)">
      <path d="M5.33333 23.8788H0V8.60607L5.33333 3.27274V24V23.8788ZM0.606061 23.2727H4.72727V4.72728L0.606061 8.9697V23.3939V23.2727Z" fill="url(#i0)"/>
      <path d="M9.93942 23.8788H4.72729V0L9.93942 3.75758V24V23.8788ZM5.33336 23.2727H9.33336V4L5.33336 1.09091V23.2727Z" fill="url(#i1)"/>
      <path d="M14.6666 23.8788H9.33331V13.0909L14.6666 9.45456V23.8788ZM9.93937 23.2727H14.0606V10.6667L9.93937 13.4546V23.2727Z" fill="url(#i2)"/>
      <path d="M19.2727 23.8788H13.9394V5.09092L16.6061 3.39395L19.2727 5.09092V23.8788ZM14.6667 23.2727H18.7879V5.45456L16.7273 4.12122L14.6667 5.45456V23.3939V23.2727Z" fill="url(#i3)"/>
      <path d="M24 23.8788H18.7879V6.66666L24 10.303V23.8788ZM19.2728 23.2727H23.2728V10.5454L19.2728 7.75757V23.2727Z" fill="url(#i4)"/>
    </g>
  </g>
</svg>`;
const svgToDataUrl = (svg) =>
  `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
const clusterRenderer = {
  render({ count, position }) {
    const size = count < 10 ? 48 : count < 100 ? 52 : 72;
    const fill = count < 10 ? "#2563eb" : count < 50 ? "#f59e0b" : "#ef4444";
    const svg = window.btoa(getClusterIconSVG(count, fill));
    return new window.google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new window.google.maps.Size(size, size),
        anchor: new window.google.maps.Point(size / 2, size / 2),
      },
      zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
    });
  },
};
const getMapBoundsArray = (map) => {
  const b = map.getBounds();
  if (!b) return null;
  const sw = b.getSouthWest();
  const ne = b.getNorthEast();
  const minLat = sw.lat();
  const minLng = sw.lng();
  const maxLat = ne.lat();
  const maxLng = ne.lng();
  return [
    [minLng, minLat],
    [maxLng, maxLat],
  ];
};
// put this near the top of your component file (outside component)
const GMAPS_SCRIPT_ID = "google-maps-js";
function loadGoogleMaps({ apiKey, libraries = ["places"] }) {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") return reject(new Error("No window"));
    // already loaded
    if (window.google?.maps) return resolve(window.google);
    // already injected?
    const existing = document.getElementById(GMAPS_SCRIPT_ID);
    if (existing) {
      // wait for it
      const onLoad = () => resolve(window.google);
      const onError = () => reject(new Error("Google Maps script failed"));
      existing.addEventListener("load", onLoad, { once: true });
      existing.addEventListener("error", onError, { once: true });
      // fallback poll (in case load event already happened before listener attach)
      const t0 = Date.now();
      const poll = setInterval(() => {
        if (window.google?.maps) {
          clearInterval(poll);
          resolve(window.google);
        } else if (Date.now() - t0 > 15000) {
          clearInterval(poll);
          reject(new Error("Google Maps load timeout"));
        }
      }, 100);
      return;
    }
    // inject script once
    const script = document.createElement("script");
    script.id = GMAPS_SCRIPT_ID;
    script.async = true;
    script.defer = true;
    const libs = encodeURIComponent(libraries.join(","));
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libs}`;
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error("Google Maps script failed"));
    document.head.appendChild(script);
    // fallback poll
    const t0 = Date.now();
    const poll = setInterval(() => {
      if (window.google?.maps) {
        clearInterval(poll);
        resolve(window.google);
      } else if (Date.now() - t0 > 15000) {
        clearInterval(poll);
        reject(new Error("Google Maps load timeout"));
      }
    }, 100);
  });
}
const NewGoogleMap = ({
  filterInput,
  ongletType,
  ongletId,
  query,
  ongletName,
  selectedProgramId,
  setSelectedProgramId,
  programmesCoordinatesData,
  programmesCoordinatesProps,
  matchingProgrammes,
  searchInputRef,
  itineraryRef,
  cityZoomLocation = null,
}) => {
  const dispatch = useDispatch();
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  // Programme InfoWindow (React)
  const infoWindowRef = useRef(null);
  const popupRootRef = useRef(null);
  // POI InfoWindow (React)
  const poiInfoWindowRef = useRef(null);
  const poiPopupRootRef = useRef(null);
  // markers + clustering
  const markersRef = useRef([]);
  const clustererRef = useRef(null);
  const markerByProgrammeIdRef = useRef(new Map());
  // Deep search
  const debounceTimerRef = useRef(null);
  const idleListenerRef = useRef(null);
  // SearchBox refs
  // const searchInputRef = useRef(null);
  const searchBoxRef = useRef(null);
  // POI categories
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [poiLoading, setPoiLoading] = useState(false);
  const placesServiceRef = useRef(null);
  const poiMarkersRef = useRef([]);
  // Load state
  const [places, setPlaces] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [mapsReady, setMapsReady] = useState(false);
  const [mapsError, setMapsError] = useState(null);
  // Geocoding
  const geocoderRef = useRef(null);
  // Directions
  const directionsServiceRef = useRef(null);
  const directionsRendererRef = useRef(null);
  // Itinerary UI refs
  const originInputRef = useRef(null);
  const destinationInputRef = useRef(null);
  const originAutocompleteRef = useRef(null);
  const destinationAutocompleteRef = useRef(null);
  // Points
  const [origin, setOrigin] = useState(null);
  const [destination, setDestination] = useState(null);
  // Labels
  const [originLabel, setOriginLabel] = useState("");
  const [destinationLabel, setDestinationLabel] = useState("");
  // Route UI
  const [routeLegs, setRouteLegs] = useState(null);
  const [hasRoute, setHasRoute] = useState(false);
  const [isRouting, setIsRouting] = useState(false);
  const [travelMode, setTravelMode] = useState("DRIVING");
  const [showRouteBox, setShowRouteBox] = useState(false);
  // Localise buttons
  const [localiseALoading, setLocaliseALoading] = useState(false);
  const [localiseBLoading, setLocaliseBLoading] = useState(false);
  const getMyLocation = useCallback(
    () =>
      new Promise((resolve, reject) => {
        if (typeof window === "undefined")
          return reject(new Error("No window"));
        if (!navigator?.geolocation)
          return reject(new Error("Geolocation not supported"));
        if (!window.google?.maps)
          return reject(new Error("Google Maps not ready yet"));
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const latLng = new window.google.maps.LatLng(
              pos.coords.latitude,
              pos.coords.longitude,
            );
            resolve({ latLng, accuracy: pos.coords.accuracy });
          },
          (err) => reject(err),
          { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 },
        );
      }),
    [],
  );
  const reverseGeocode = useCallback(
    (latLng) =>
      new Promise((resolve) => {
        const geocoder = geocoderRef.current;
        if (!geocoder || !latLng) return resolve("");
        geocoder.geocode({ location: latLng }, (results, status) => {
          if (status === "OK" && results?.[0]?.formatted_address) {
            resolve(results[0].formatted_address);
          } else {
            resolve("");
          }
        });
      }),
    [],
  );
  const reactIconToDataUrl = useCallback((iconEl) => {
    const svg = renderToStaticMarkup(iconEl);
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  }, []);
  // -----------------------------
  // Setters A / B (passed to popups)
  // -----------------------------
  const onSetPointA = useCallback(
    async ({ latLng, label }) => {
      if (!latLng) return;
      setShowRouteBox(true);
      setOrigin(latLng);
      let finalLabel = label || "";
      if (!finalLabel) {
        const addr = await reverseGeocode(latLng);
        finalLabel =
          addr || `${latLng.lat().toFixed(6)}, ${latLng.lng().toFixed(6)}`;
      }
      setOriginLabel(finalLabel);
      if (originInputRef.current) originInputRef.current.value = finalLabel;
    },
    [reverseGeocode],
  );
  const onSetPointB = useCallback(
    async ({ latLng, label }) => {
      if (!latLng) return;
      setShowRouteBox(true);
      setDestination(latLng);
      let finalLabel = label || "";
      if (!finalLabel) {
        const addr = await reverseGeocode(latLng);
        finalLabel =
          addr || `${latLng.lat().toFixed(6)}, ${latLng.lng().toFixed(6)}`;
      }
      setDestinationLabel(finalLabel);
      if (destinationInputRef.current)
        destinationInputRef.current.value = finalLabel;
    },
    [reverseGeocode],
  );
  // -----------------------------
  // Localise actions (FIXED)
  // -----------------------------
  const localiseToA = useCallback(async () => {
    // guard
    if (!mapsReady) return;
    try {
      setLocaliseALoading(true);
      const { latLng } = await getMyLocation();
      await onSetPointA({ latLng, label: "Ma position" });
      const map = mapInstanceRef.current;
      if (map) {
        map.panTo(latLng);
        const z = map.getZoom();
        if (typeof z === "number" && z < 13) map.setZoom(13);
      }
    } catch (e) {
      // optional: console only (no UI change)
      console.error("Geolocation A failed:", e);
    } finally {
      setLocaliseALoading(false);
    }
  }, [mapsReady, getMyLocation, onSetPointA]);
  const localiseToB = useCallback(async () => {
    if (!mapsReady) return;
    try {
      setLocaliseBLoading(true);
      const { latLng } = await getMyLocation();
      await onSetPointB({ latLng, label: "Ma position" });
      const map = mapInstanceRef.current;
      if (map) {
        map.panTo(latLng);
        const z = map.getZoom();
        if (typeof z === "number" && z < 13) map.setZoom(13);
      }
    } catch (e) {
      console.error("Geolocation B failed:", e);
    } finally {
      setLocaliseBLoading(false);
    }
  }, [mapsReady, getMyLocation, onSetPointB]);
  // -----------------------------
  // Category buttons
  // -----------------------------
  const categoryButtons = [
    {
      icon: (
        <School
          fill={selectedCategory?.value === "school" ? "#292D32" : "#fff"}
        />
      ),
      iconMap: <School />,
      label: "Écoles",
      value: "school",
      excluded:
        "tutor,dormitory,community_college,university_book_store,university_laboratory,health",
    },
    {
      icon: (
        <Hospital
          fill={selectedCategory?.value === "hospital" ? "#292D32" : "#fff"}
        />
      ),
      iconMap: <Hospital />,
      label: "Hôpitaux",
      value: "hospital",
      excluded: "medical_laboratory,pharmacy,doctors_office,dentist",
    },
    {
      icon: (
        <Airport
          fill={selectedCategory?.value === "airport" ? "#292D32" : "#fff"}
        />
      ),
      iconMap: <Airport />,
      label: "Aéroports",
      value: "airport",
      excluded: "lodging,car_rental,taxi_stand,parking",
    },
    {
      icon: (
        <Cart
          fill={selectedCategory?.value === "supermarket" ? "#292D32" : "#fff"}
        />
      ),
      iconMap: <Cart />,
      label: "Supermarchés",
      value: "supermarket",
      excluded: "",
    },
    {
      icon: (
        <Restaurants
          fill={selectedCategory?.value === "restaurant" ? "#292D32" : "#fff"}
        />
      ),
      iconMap: <Restaurants />,
      label: "Restaurants",
      value: "restaurant",
      excluded: "",
    },
    {
      icon: (
        <Banques
          fill={selectedCategory?.value === "bank" ? "#292D32" : "#fff"}
        />
      ),
      iconMap: <Banques />,
      label: "Banques",
      value: "bank",
      excluded: "",
    },
  ];
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // if you keep Script, at least do the "already loaded" check:
        if (window.google?.maps) {
          if (!cancelled) setMapsReady(true);
          return;
        }
        await loadGoogleMaps({
          apiKey: "AIzaSyA4m5vfwsuRsuPqKLPuFUmm-niBsZ0WXuY",
          libraries: ["places"],
        });
        if (!cancelled) setMapsReady(true);
      } catch (e) {
        if (!cancelled) {
          setMapsError(e);
          setMapsReady(false);
        }
        console.error("Google Maps load error:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  // Update places when programmesCoordinatesData changes (from props/redux)
  useEffect(() => {
    if (programmesCoordinatesData && programmesCoordinatesData.length > 0) {
      setPlaces(programmesCoordinatesData);
      setIsLoading(false);
    }
  }, [programmesCoordinatesData]);
  // -----------------------------
  // Init map (KEEP DEFAULT CONTROLS)
  // -----------------------------
  useEffect(() => {
    if (!mapsReady) return;
    if (!mapRef.current) return;
    if (mapInstanceRef.current) return;
    mapInstanceRef.current = new window.google.maps.Map(mapRef.current, {
      center: { lat: 46.2276, lng: 2.2137 },
      zoom: 6,
      gestureHandling: "greedy",
      scrollwheel: true,
    });
  }, [mapsReady]);
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    let cancelled = false;
    (async () => {
      try {
        const { latLng } = await getMyLocation();
        if (cancelled) return;
        // center map only (no filling A/B)
        map.panTo(latLng);
        const z = map.getZoom();
        if (typeof z === "number" && z < 12) map.setZoom(12);
      } catch (e) {
        // silent
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [mapsReady, getMyLocation]);
  // Geocoder init
  useEffect(() => {
    if (!mapsReady) return;
    if (!geocoderRef.current)
      geocoderRef.current = new window.google.maps.Geocoder();
  }, [mapsReady]);
  // PlacesService init
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    if (!placesServiceRef.current && window.google?.maps?.places) {
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        map,
      );
    }
  }, [mapsReady]);
  // SearchBox init
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    if (!searchInputRef.current) return;
    if (!window.google?.maps?.places) return;
    if (searchBoxRef.current) return;
    const sb = new window.google.maps.places.SearchBox(searchInputRef.current);
    const listener = sb.addListener("places_changed", () => {
      const results = sb.getPlaces() || [];
      const place = results[0];
      if (!place?.geometry) return;
      if (place.geometry.viewport) map.fitBounds(place.geometry.viewport);
      else if (place.geometry.location) {
        map.setCenter(place.geometry.location);
        map.setZoom(14);
      }
    });
    searchBoxRef.current = sb;
    return () => {
      if (listener) window.google.maps.event.removeListener(listener);
      searchBoxRef.current = null;
    };
  }, [mapsReady]);
  // Handle cityZoomLocation - zoom to location when set (from mobile filter)
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    if (!cityZoomLocation) return;
    const { lng, lat } = cityZoomLocation;
    map.setCenter({ lat, lng });
    map.setZoom(14);
  }, [mapsReady, cityZoomLocation]);
  // Directions init
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    if (!directionsServiceRef.current) {
      directionsServiceRef.current = new window.google.maps.DirectionsService();
    }
    if (!directionsRendererRef.current) {
      directionsRendererRef.current = new window.google.maps.DirectionsRenderer(
        {
          map,
          suppressMarkers: false,
          preserveViewport: false,
        },
      );
    }
  }, [mapsReady]);
  // Autocomplete init
  // ✅ FIX: ensure listeners aren’t attached before maps is ready, and keep stable callbacks.
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    if (!window.google?.maps?.places) return;
    if (originInputRef.current && !originAutocompleteRef.current) {
      originAutocompleteRef.current =
        new window.google.maps.places.Autocomplete(originInputRef.current, {
          fields: ["geometry", "name", "formatted_address"],
        });
      originAutocompleteRef.current.addListener("place_changed", async () => {
        const p = originAutocompleteRef.current.getPlace();
        if (!p?.geometry?.location) return;
        const label = p.formatted_address || p.name || "";
        await onSetPointA({ latLng: p.geometry.location, label });
      });
    }
    if (destinationInputRef.current && !destinationAutocompleteRef.current) {
      destinationAutocompleteRef.current =
        new window.google.maps.places.Autocomplete(
          destinationInputRef.current,
          {
            fields: ["geometry", "name", "formatted_address"],
          },
        );
      destinationAutocompleteRef.current.addListener(
        "place_changed",
        async () => {
          const p = destinationAutocompleteRef.current.getPlace();
          if (!p?.geometry?.location) return;
          const label = p.formatted_address || p.name || "";
          await onSetPointB({ latLng: p.geometry.location, label });
        },
      );
    }
  }, [mapsReady, onSetPointA, onSetPointB]);
  // Map click => you commented it, we keep it commented as requested
  const mapClickListenerRef = useRef(null);
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    if (mapClickListenerRef.current) {
      window.google.maps.event.removeListener(mapClickListenerRef.current);
      mapClickListenerRef.current = null;
    }
    mapClickListenerRef.current = map.addListener("click", async (e) => {
      if (!e?.latLng) return;
      await onSetPointA({ latLng: e.latLng });
    });
    return () => {
      if (mapClickListenerRef.current) {
        window.google.maps.event.removeListener(mapClickListenerRef.current);
        mapClickListenerRef.current = null;
      }
    };
  }, [mapsReady, onSetPointA]);
  // Build route
  const buildRoute = useCallback(async () => {
    const map = mapInstanceRef.current;
    const service = directionsServiceRef.current;
    const renderer = directionsRendererRef.current;
    if (!map || !service || !renderer) return;
    if (!origin || !destination) return;
    setIsRouting(true);
    const request = {
      origin,
      destination,
      travelMode: window.google.maps.TravelMode[travelMode],
    };
    service.route(request, (result, status) => {
      setIsRouting(false);
      if (status === "OK" && result) {
        renderer.setDirections(result);
        const leg = result?.routes?.[0]?.legs?.[0] || null;
        setRouteLegs(leg);
        setHasRoute(true);
      } else {
        renderer.setDirections({ routes: [] });
        setRouteLegs(null);
        setHasRoute(false);
      }
    });
  }, [origin, destination, travelMode]);
  // Recalc route if A/B change AND route exists
  useEffect(() => {
    if (!hasRoute) return;
    if (!origin || !destination) return;
    buildRoute();
  }, [origin, destination, travelMode, hasRoute, buildRoute]);
  const resetRoute = useCallback(() => {
    directionsRendererRef.current?.setDirections({ routes: [] });
    setHasRoute(false);
    setRouteLegs(null);
    setIsRouting(false);
    setOrigin(null);
    setDestination(null);
    setOriginLabel("");
    setDestinationLabel("");
    if (originInputRef.current) originInputRef.current.value = "";
    if (destinationInputRef.current) destinationInputRef.current.value = "";
  }, []);
  // Programme popup opener
  const openInfoWindowProgramme = useCallback(
    (map, marker, documentId) => {
      if (!infoWindowRef.current) {
        infoWindowRef.current = new window.google.maps.InfoWindow();
      }
      poiInfoWindowRef.current?.close();
      poiPopupRootRef.current?.unmount();
      poiPopupRootRef.current = null;
      popupRootRef.current?.unmount();
      popupRootRef.current = null;
      setSelectedProgramId?.(documentId);
      const container = document.createElement("div");
      infoWindowRef.current.setContent(container);
      infoWindowRef.current.open({ map, anchor: marker });
      const root = createRoot(container);
      popupRootRef.current = root;
      const markerPos = marker.getPosition();
      root.render(
        <ProgrammeInfoWindow
          documentId={documentId}
          markerLat={markerPos?.lat?.()}
          markerLng={markerPos?.lng?.()}
          onSetPointA={onSetPointA}
          onSetPointB={onSetPointB}
          onViewMore={(id) => dispatch(fetchSingleProgram(id, true))}
        />,
      );
      window.google.maps.event.addListenerOnce(
        infoWindowRef.current,
        "closeclick",
        () => {
          popupRootRef.current?.unmount();
          popupRootRef.current = null;
          setSelectedProgramId?.(null);
        },
      );
    },
    [dispatch, onSetPointA, onSetPointB, setSelectedProgramId],
  );
  // Cleanup on unmount
  useEffect(() => {
    return () => {
      popupRootRef.current?.unmount();
      popupRootRef.current = null;
      poiPopupRootRef.current?.unmount();
      poiPopupRootRef.current = null;
    };
  }, []);
  // Programmes markers + clustering
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    if (clustererRef.current) {
      clustererRef.current.clearMarkers();
      clustererRef.current = null;
    }
    markersRef.current.forEach((m) => m.setMap(null));
    markersRef.current = [];
    markerByProgrammeIdRef.current.clear();
    const blueIconUrl = svgToDataUrl(MAP_ICON_SVG_BLUE);
    const pinkIconUrl = svgToDataUrl(MAP_ICON_SVG_PINK);
    const markers = (places || [])
      .map((p) => {
        const lat = Number(p?.lat ?? p?.latitude);
        const lng = Number(p?.lng ?? p?.longitude);
        const programmeId = p?.documentId;
        const iconUrl = p?.isRp ? pinkIconUrl : blueIconUrl;
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
        if (!programmeId) return null;
        const marker = new window.google.maps.Marker({
          position: { lat, lng },
          icon: {
            url: iconUrl,
            scaledSize: new window.google.maps.Size(44, 50),
            anchor: new window.google.maps.Point(16, 16),
          },
        });
        markerByProgrammeIdRef.current.set(programmeId, marker);
        marker.addListener("click", () => {
          openInfoWindowProgramme(map, marker, programmeId);
          const pos = marker.getPosition();
          // if (pos) onSetPointA({ latLng: pos, label: p?.name || "Programme" });
        });
        return marker;
      })
      .filter(Boolean);
    markersRef.current = markers;
    clustererRef.current = new MarkerClusterer({
      map,
      markers,
      renderer: clusterRenderer,
      algorithm: new SuperClusterAlgorithm({
        radius: 200,
        maxZoom: CLUSTER_MAX_ZOOM,
      }),
    });
    return () => {
      if (clustererRef.current) clustererRef.current.clearMarkers();
      markersRef.current.forEach((m) => m.setMap(null));
      markersRef.current = [];
      markerByProgrammeIdRef.current.clear();
    };
  }, [places, mapsReady, openInfoWindowProgramme, onSetPointA]);
  useEffect(() => {
    if (!mapsReady) return;
    //  const { piecesMin, piecesMax, priceMin, priceMax } = filters;
    // if (filters.used) {
    const allowed = new Set((matchingProgrammes || []).map(String));
    // update only opacity on existing markers
    for (const [
      programmeId,
      marker,
    ] of markerByProgrammeIdRef.current.entries()) {
      const isAllowed = allowed.has(String(programmeId));
      marker.setOpacity(isAllowed ? 1 : 0.1);
    }
    // optionnel: si tu veux que les clusters se recalculent visuellement
    // (pas toujours nécessaire, mais utile si tu constates un rendu "figé")
    clustererRef.current?.repaint?.();
    // }
  }, [programmesCoordinatesProps, mapsReady, matchingProgrammes]);
  // Open programmatically when selectedProgramId changes (keep your commented part commented)
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    if (!selectedProgramId) {
      infoWindowRef.current?.close();
      return;
    }
    const marker = markerByProgrammeIdRef.current.get(selectedProgramId);
    if (!marker) return;
    const targetPos = marker.getPosition();
    map.panTo(targetPos);
    const currentZoom = map.getZoom();
    if (typeof currentZoom === "number" && currentZoom < CLUSTER_MAX_ZOOM) {
      map.setZoom(14);
    }
    openInfoWindowProgramme(map, marker, selectedProgramId);
    // if (targetPos) onSetPointA({ latLng: targetPos, label: "Programme" });
  }, [selectedProgramId, mapsReady, openInfoWindowProgramme, onSetPointA]);
  // DeepSearch on idle (debounced) - only triggers when map bounds change
  const prevBoundsRef = useRef(null);
  const selectedProgramIdRef = useRef(selectedProgramId);

  // FIX TO STOP MAP FROM RELOADING AND CLOSEING THE MARKER WHEN SELECTING A PROGRAM
  useEffect(() => {
    selectedProgramIdRef.current = selectedProgramId;
  }, [selectedProgramId]);

  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!mapsReady || !map) return;
    const onIdle = () => {
      // Skip deep search if an InfoWindow is open (user is viewing a program)
      if (selectedProgramIdRef.current) return;
      const mapBounds = getMapBoundsArray(map);
      if (!mapBounds) return;
      const [[minLng, minLat], [maxLng, maxLat]] = mapBounds;
      const boundsKey = `${minLat.toFixed(4)},${maxLat.toFixed(4)},${minLng.toFixed(4)},${maxLng.toFixed(4)}`;
      // Only trigger search if bounds actually changed
      if (prevBoundsRef.current === boundsKey) return;
      prevBoundsRef.current = boundsKey;
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = setTimeout(() => {
        let searchParams = { ...(query || {}), minLat, maxLat, minLng, maxLng };
        dispatch(
          deepSearchFunction(
            searchParams,
            ongletType || "stock",
            ongletId || "stock",
            ongletName || "Stock",
            true,
          ),
        );
      }, 350);
    };
    if (idleListenerRef.current) {
      window.google.maps.event.removeListener(idleListenerRef.current);
      idleListenerRef.current = null;
    }
    idleListenerRef.current = map.addListener("idle", onIdle);
    return () => {
      if (idleListenerRef.current) {
        window.google.maps.event.removeListener(idleListenerRef.current);
        idleListenerRef.current = null;
      }
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = null;
      }
    };
  }, [mapsReady, query, ongletType, ongletId, ongletName, dispatch]);
  // POI popup opener
  const openPoiInfoWindow = useCallback(
    (map, marker, place) => {
      if (!map || !marker || !place) return;
      if (!poiInfoWindowRef.current) {
        poiInfoWindowRef.current = new window.google.maps.InfoWindow();
      }
      infoWindowRef.current?.close();
      popupRootRef.current?.unmount();
      popupRootRef.current = null;
      setSelectedProgramId?.(null);
      poiPopupRootRef.current?.unmount();
      poiPopupRootRef.current = null;
      const container = document.createElement("div");
      poiInfoWindowRef.current.setContent(container);
      poiInfoWindowRef.current.open({ map, anchor: marker });
      const root = createRoot(container);
      poiPopupRootRef.current = root;
      const pos = marker.getPosition();
      root.render(
        <PoiInfoWindow
          placeId={place.place_id}
          fallbackName={place.name}
          fallbackVicinity={place.vicinity}
          markerLat={pos?.lat?.()}
          markerLng={pos?.lng?.()}
          placesService={placesServiceRef.current}
          onSetPointA={onSetPointA}
          onSetPointB={onSetPointB}
        />,
      );
      window.google.maps.event.addListenerOnce(
        poiInfoWindowRef.current,
        "closeclick",
        () => {
          poiPopupRootRef.current?.unmount();
          poiPopupRootRef.current = null;
        },
      );
    },
    [onSetPointA, onSetPointB, setSelectedProgramId],
  );
  // POI markers fetch + click
  useEffect(() => {
    const map = mapInstanceRef.current;
    const service = placesServiceRef.current;
    if (!mapsReady || !map || !service) return;
    if (!selectedCategory) {
      clearPoiMarkers(poiMarkersRef);
      return;
    }
    let cancelled = false;
    const run = async () => {
      setPoiLoading(true);
      clearPoiMarkers(poiMarkersRef);
      const center = map.getCenter();
      const bounds = map.getBounds();
      if (!center || !bounds) {
        setPoiLoading(false);
        return;
      }
      const radius = Math.min(
        50000,
        Math.max(1000, haversineMeters(center, bounds.getNorthEast())),
      );
      const types = (selectedCategory.value || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const excluded = new Set(
        (selectedCategory.excluded || "")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean),
      );
      const all = new Map();
      const nearby = (type) =>
        new Promise((resolve) => {
          service.nearbySearch(
            { location: center, radius, type },
            (results, status) => {
              if (
                status === window.google.maps.places.PlacesServiceStatus.OK &&
                results
              ) {
                resolve(results);
              } else {
                resolve([]);
              }
            },
          );
        });
      for (const t of types.length ? types : ["restaurant"]) {
        const res = await nearby(t);
        res.forEach((p) => {
          if (!p?.place_id) return;
          all.set(p.place_id, p);
        });
        if (cancelled) return;
      }
      const filtered = Array.from(all.values()).filter((p) => {
        const t = p.types || [];
        return !t.some((x) => excluded.has(x));
      });
      const iconUrl = reactIconToDataUrl(selectedCategory.iconMap);
      const markers = filtered
        .map((p) => {
          const loc = p.geometry?.location;
          if (!loc) return null;
          const m = new window.google.maps.Marker({
            map,
            position: loc,
            title: p.name || selectedCategory.label,
            icon: {
              url: iconUrl,
              scaledSize: new window.google.maps.Size(28, 28),
              anchor: new window.google.maps.Point(14, 14),
            },
          });
          m.addListener("click", async () => {
            openPoiInfoWindow(map, m, p);
            const pos = m.getPosition();
            // if (pos)
            //   await onSetPointA({ latLng: pos, label: p?.name || "POI" });
          });
          return m;
        })
        .filter(Boolean);
      if (!cancelled) poiMarkersRef.current = markers;
      setPoiLoading(false);
    };
    run();
    return () => {
      cancelled = true;
      setPoiLoading(false);
    };
  }, [selectedCategory, mapsReady, reactIconToDataUrl, openPoiInfoWindow]);
  return (
    <div className="position-relative h100 w100">
      {/* <Script
        src={`https://maps.googleapis.com/maps/api/js?key=AIzaSyA4m5vfwsuRsuPqKLPuFUmm-niBsZ0WXuY&libraries=places`}
        strategy="afterInteractive"
        onLoad={() => setMapsReady(true)}
      /> */}
      {!mapsReady ||
        (isLoading && (
          <div
            style={{
              width: "100%",
              height: "100%",
              borderRadius: 12,
              background: "#eee",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#666",
              fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial",
              marginBottom: 12,
            }}
          >
            Chargement de la carte
          </div>
        ))}
      {/* ${showRouteBox ? "showRouteBox" : ""} */}
      {/* ROUTE BOX */}
      {/* TODO PUT THIS IN PARENT */}
      {!itineraryRef.current
        ? null
        : createPortal(
            <div
              className={`border mb-2`}
              style={{
                transition: "all 0.2s ease-in-out",
                width: "100%",
                background: "white",
                borderRadius: 12,
                padding: 10,
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
              {/* ORIGIN */}
              {showRouteBox && (
                <div style={{ position: "relative" }}>
                  <input
                    ref={originInputRef}
                    placeholder="Point A"
                    style={{
                      width: "100%",
                      height: 40,
                      borderRadius: 10,
                      border: "1px solid #e5e7eb",
                      padding: "0 40px 0 12px",
                      outline: "none",
                    }}
                    defaultValue={originLabel}
                  />
                  <button
                    type="button"
                    onClick={localiseToA}
                    title="Utiliser ma position (Point A)"
                    style={{
                      position: "absolute",
                      right: 6,
                      top: 6,
                      width: 28,
                      height: 28,
                      borderRadius: 8,
                      border: "1px solid #e5e7eb",
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    {localiseALoading ? (
                      <Spinner size="sm" />
                    ) : (
                      <LocaliseIcon />
                    )}
                  </button>
                </div>
              )}
              {/* DESTINATION */}
              {showRouteBox && (
                <div style={{ position: "relative" }}>
                  <input
                    ref={destinationInputRef}
                    placeholder="Point B"
                    style={{
                      width: "100%",
                      height: 40,
                      borderRadius: 10,
                      border: "1px solid #e5e7eb",
                      padding: "0 40px 0 12px",
                      outline: "none",
                    }}
                    defaultValue={destinationLabel}
                  />
                  <button
                    type="button"
                    onClick={localiseToB}
                    title="Utiliser ma position (Point B)"
                    style={{
                      position: "absolute",
                      right: 6,
                      top: 6,
                      width: 28,
                      height: 28,
                      borderRadius: 8,
                      border: "1px solid #e5e7eb",
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    {localiseBLoading ? (
                      <Spinner size="sm" />
                    ) : (
                      <LocaliseIcon />
                    )}
                  </button>
                </div>
              )}
              {/* Mode selectors */}
              {showRouteBox && (
                <div style={{ display: "flex", gap: 8 }}>
                  {[
                    {
                      k: "TRANSIT",
                      label: (
                        <IconBus
                          fill={travelMode === "TRANSIT" ? "white" : "#111827"}
                        />
                      ),
                    },
                    {
                      k: "DRIVING",
                      label: (
                        <CarIcon
                          fill={travelMode === "DRIVING" ? "white" : "#111827"}
                        />
                      ),
                    },
                    {
                      k: "BICYCLING",
                      label: (
                        <BikeIcon
                          fill={
                            travelMode === "BICYCLING" ? "white" : "#111827"
                          }
                        />
                      ),
                    },
                    {
                      k: "WALKING",
                      label: (
                        <WalkIcon
                          fill={travelMode === "WALKING" ? "white" : "#111827"}
                        />
                      ),
                    },
                  ].map((m) => (
                    <button
                      key={m.k}
                      type="button"
                      onClick={() => setTravelMode(m.k)}
                      style={{
                        flex: 1,
                        height: 40,
                        borderRadius: 10,
                        border: "1px solid #e5e7eb",
                        background: travelMode === m.k ? "#111827" : "white",
                        color: travelMode === m.k ? "white" : "#111827",
                        cursor: "pointer",
                        fontSize: 18,
                      }}
                    >
                      {m.label}
                    </button>
                  ))}
                </div>
              )}
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="flex-1"
                  onClick={buildRoute}
                  disabled={!origin || !destination || isRouting}
                  style={{
                    height: 42,
                    borderRadius: 10,
                    border: "none",
                    background: "#2563eb",
                    color: "white",
                    fontWeight: 700,
                    cursor: "pointer",
                    opacity: !origin || !destination || isRouting ? 0.6 : 1,
                  }}
                >
                  {isRouting ? "Calcul…" : "Obtenir l’itinéraire"}
                </button>
                {showRouteBox ? (
                  <button
                    type="button"
                    onClick={() => resetRoute()}
                    disabled={
                      (!origin && !destination && !hasRoute) || isRouting
                    }
                    title="Réinitialiser"
                    className="border"
                    style={{
                      width: 46,
                      height: 42,
                      borderRadius: 10,
                      background: "white",
                      cursor: "pointer",
                      opacity:
                        (!origin && !destination && !hasRoute) || isRouting
                          ? 0.6
                          : 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ResetIcon />
                  </button>
                ) : null}
                <button
                  type="button"
                  onClick={() => setShowRouteBox(!showRouteBox)}
                  title="Réinitialiser"
                  className={`border ${showRouteBox ? "rotatedCloseIcon" : ""}`}
                  style={{
                    outline: "none",
                    width: 46,
                    height: 42,
                    borderRadius: 10,
                    background: "white",
                    cursor: "pointer",
                    opacity:
                      (!origin && !destination && !hasRoute) || isRouting
                        ? 0.6
                        : 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ChevronDownIcon />
                </button>
              </div>
              {showRouteBox ? <MapDirectionsBox legs={routeLegs} /> : null}
            </div>,
            itineraryRef.current,
          )}
      {/* CATEGORY BUTTONS */}
      <div
        className="hideScrollbar "
        style={{
          position: "absolute",
          bottom: 0,
          left: 12,
          right: 12,
          zIndex: 20,
          display: !mapsReady || isLoading ? "none" : "flex",
          gap: 8,
          overflowX: "auto",
          padding: 6,
          maxWidth: "80%",
        }}
      >
        {categoryButtons.map((c) => {
          const active = selectedCategory?.value === c.value;
          return (
            <button
              key={c.label}
              type="button"
              onClick={() => setSelectedCategory(active ? null : c)}
              style={{
                flex: "0 0 auto",
                height: 32,
                padding: "0 12px",
                borderRadius: 999,
                border: "1px solid #e5e7eb",
                background: active ? "#111827" : "white",
                color: active ? "white" : "#111827",
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              <span style={{ display: "inline-flex" }}>
                {poiLoading && active ? (
                  <Spinner size="sm" />
                ) : (
                  React.cloneElement(c.icon, {
                    fill: active ? "white" : "#111827",
                  })
                )}
              </span>
              <span style={{ fontWeight: 700, fontSize: 12 }}>{c.label}</span>
            </button>
          );
        })}
      </div>
      {/* SearchBox */}
      {/* <div style={{ position: "relative" }}>
        <input
          //TODO PUT THIS IN PARENT AND PASS REF AS PROPS
          ref={searchInputRef}
          placeholder="Rechercher…"
          className="border radius10 me-1"
          style={{
            boxSizing: "border-box",
            border: "1px solid transparent",
            width: 320,
            height: 40,
            padding: "0 12px",
            outline: "none",
            fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial",
            fontSize: 14,
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            backgroundColor: "#fff",
            display: !mapsReady || isLoading ? "none" : "block",
          }}
        />
        <button
          type="button"
          onClick={() => {
            getMyLocation();
          }}
          title="Utiliser ma position"
          style={{
            position: "absolute",
            right: 6,
            top: 6,
            width: 28,
            height: 28,
            borderRadius: 8,
            border: "1px solid #e5e7eb",
            background: "white",
            cursor: "pointer",
            zIndex: 2,
          }}
        >
          {localiseBLoading ? <Spinner size="sm" /> : <LocaliseIcon />}
        </button>
      </div> */}
      {/* MAP */}
      <div
        ref={mapRef}
        className="radius10"
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      />
    </div>
  );
};
export default NewGoogleMap;
